export default {
  DashRedirect: '/dash/redirect',
  NewSignupRedirect: '/dash/redirect/new',
  EventDash: '/dash/team/:teamId/event/:eventId',
  EventDashTrash: '/dash/team/:teamId/event/:eventId/trash',
  EventDashSaved: '/dash/team/:teamId/event/:eventId/saved',
  EventDashShowTemplates: '/dash/team/:teamId/event/:eventId/templates',
  EventDashFolder: '/dash/team/:teamId/event/:eventId/folder/:folderId',
  EventDashTab: '/dash/team/:teamId/event/:eventId/:tab',
  TeamDash: '/dash/team/:teamId',
  UserDash: '/dash/user',
  UpgradeRedirect: '/upgrade',
};
